//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RequestWorkTypeDoneIndicator from './RequestWorkTypeDoneIndicator.vue'
import RequestWorkTypeReportInclusionMode from './RequestWorkTypeReportInclusionMode.vue'
import RequestWorkTypeRequiredIcon from './RequestWorkTypeRequiredIcon'
import RequestWorkTypeIncludedInWorkPackagesIndicator from './RequestWorkTypeIncludedInWorkPackagesIndicator'
import { LABEL_MARKS } from './RequestWorkTypes.js'

export default {
  name: 'RequestWorkTypeListElement',
  components: {
    RequestWorkTypeReportInclusionMode,
    RequestWorkTypeDoneIndicator,
    RequestWorkTypeRequiredIcon,
    RequestWorkTypeIncludedInWorkPackagesIndicator
  },
  props: {
    workType: {
      type: Object,
      required: true
    },
    workTypeInitial: {
      type: Object,
      default () {
        return null
      }
    },
    workTypeStandalone: {
      type: Boolean,
      default: true
    },
    workPackagesWithWorkType: {
      type: Array,
      default: () => [] // [ { id, name, current }, ... ]
    },
    request: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    },
    hideDeleteBtn: {
      type: Boolean,
      default: false
    },
    hideInclusionMode: {
      type: Boolean,
      default: false
    },
    hideIndicators: {
      type: Boolean,
      default: false
    },
    showWorkPackageIndicator: {
      type: Boolean,
      default: false
    },
    isNotSaved: {
      type: Boolean,
      default: false
    },
    engineerView: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      workTypeLocal: JSON.parse(JSON.stringify(this.workType)),
      workTypeMark: LABEL_MARKS.workType
    }
  },
  computed: {
    showDeleteBtn: function () {
      return this.editable && !this.hideDeleteBtn &&
      (!this.workType.done && !this.workType.hasDonePartiallyReports &&
      !this.workType.workPackages && !this.workType.reportsHasStandaloneDoneResult) ||
      this.isNotSaved
    },
    isAutoAssignWorkType: function () {
      return this.request.autoAssignBrigadeWorkTypes && (
        this.request.autoAssignBrigadeWorkTypes.map(wT => wT.id).includes(this.workType.id) ||
        this.request.autoAssignBrigadeWorkPackages.map(wP => wP.workTypes).flat().map(wT => wT.id).includes(this.workType.id)
      )
    },
    isRepeatedWorkType: function () {
      return this.workType.hasDoneReports || this.workType.hasDonePartiallyReports
    },
    isAdditionalWorkType: function () {
      return !!this.workType.additional
    }
  },
  watch: {
    workType: {
      handler (newValue) {
        this.workTypeLocal = JSON.parse(JSON.stringify(newValue))
      },
      deep: true
    }
  },
  methods: {
    onSelectMode: function (event) {
      this.$emit('select-inclusion-mode', event)
    },
    onDeleteWorkType: function (event) {
      this.$emit('delete', this.workTypeLocal)
    }
  }
}
